import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=71885bbc&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"
import style0 from "./loading.vue?vue&type=style&index=0&id=71885bbc&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\i\\au_kyujin_web\\src\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71885bbc')) {
      api.createRecord('71885bbc', component.options)
    } else {
      api.reload('71885bbc', component.options)
    }
    module.hot.accept("./loading.vue?vue&type=template&id=71885bbc&", function () {
      api.rerender('71885bbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Frontend/components/loading.vue"
export default component.exports